export default __webpack_public_path__ + "static/media/logo_scantrip_white.36d94df8.svg";